<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">{{ $store.state.themeTitle }}课程大纲</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1"></OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择所属院系" style="width:320px;" @focus="dialogOpen1" @clear="handeleClear1" clearable></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="审批状态">
          <el-select v-model="formInline.status" clearable filterable placeholder="请选择审批状态">
            <el-option v-for="item in $store.state.applyStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="大纲名称">
          <el-input v-model="formInline.name" clearable placeholder="请输入大纲名称"></el-input>
        </el-form-item>
        <el-form-item label="所属课程">
          <el-select v-model="formInline.class_plan_id" clearable filterable placeholder="请选择所属实训">
            <el-option v-for="item in wdsxsqs" :key="item.id" :label="item.course_name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增{{ $store.state.themeTitle }}课程大纲</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="downloadFile">下载实训导入模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile"  @refresh="handleQuery" :action="action" :params="params" :btnTitle="btnTitle"></Importt>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :disabled="exportTitle=='导出中...'" @click="handleExportByUrl(formInline)">{{exportTitle}}</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed prop="name" label="大纲名称" min-width="150">
        </custom-table-column>
        <custom-table-column prop="class_plan" label="所属课程" width="180">
        </custom-table-column>
        <custom-table-column prop="score" label="学分" width="80">
        </custom-table-column>
        <custom-table-column prop="xs" label="学时" width="80">
        </custom-table-column>
        <custom-table-column prop="jc" label="教材" width="180">
        </custom-table-column>
        <custom-table-column prop="cks" label="参考书" width="180">
        </custom-table-column>
        <custom-table-column prop="kcnr" label="课程内容" min-width="180">
        </custom-table-column>
        <custom-table-column prop="syxm" :label="`${$store.state.themeTitle}项目`" min-width="180">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button> -->
            <el-button @click="handleEdit(scope.row, ['school_Id', 'created_at', 'deleted_at'])" type="text"
              size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="706px">
      <!-- <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell" @handleOrganQuery="handleOrganQuery"></OrganDialog> -->
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
        <el-form-item label="大纲名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入大纲名称" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="所属课程" prop="class_plan_id">
          <el-select v-model="ruleForm.class_plan_id" filterable style="width:216px;" placeholder="请选择实训"
            @change="handleClassChange">
            <el-option v-for="item in wdsxsqs" :key="item.id" :label="item.course_name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学  分" prop="score">
          <el-input-number v-model="ruleForm.score" :min="0" placeholder="请输入学分" style="width:216px;"></el-input-number>
        </el-form-item>
        <el-form-item label="学  时" prop="xs">
          <el-input-number v-model="ruleForm.xs" :min="0" placeholder="请输入学时" style="width:216px;"></el-input-number>
        </el-form-item>
        <el-form-item label="教  材" prop="jc">
          <el-input v-model="ruleForm.jc" placeholder="请输入教材" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="参 考 书" prop="cks">
          <el-input v-model="ruleForm.cks" placeholder="请输入参考书" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="课程内容" prop="kcnr">
          <el-input type="textarea" v-model="ruleForm.kcnr" placeholder="请输入课程内容" :rows="3"
            style="width:542px;"></el-input>
        </el-form-item>
        <el-form-item label="实验项目" prop="syxm">
          <el-input type="textarea" v-model="ruleForm.syxm" placeholder="请输入实验项目" :rows="3"
            style="width:542px;"></el-input>
        </el-form-item>

        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'" @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
    <!-- <OrganDialog ref="organDia"></OrganDialog> -->
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
// import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinImport } from '@/assets/js/mixin/import';
// import { mixinValidate } from '@/assets/js/mixin/validate';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinImport],
  data() {
    return {
      formInline: {
        name: '',
        training_id: '',
      },
      selectName: '',
      organLabel: '',
      levell: [1, 2],
      ruleForm: {
        name: '',
        class_plan_id: '',
        class_plan: '',
        score: 0,
        xs: 0,
        kcnr: '',
        jc: '',
        cks: '',
        syxm: '',
      },
      plist: [],
      ruleForm1: {
        sxnr: '',
        xs: 0,
        bz: '',
      },
      numberDialogVisible: false,
      classRooms: [],
      rules: {
        name: [{ required: true, message: '请输入大纲名称', trigger: 'blur' }],
        class_plan_id: [{ required: true, message: `请选择${this.$store.state.themeTitle}室`, trigger: 'change' }],
        score: [{ required: true, message: '请输入学分', trigger: 'blur' }],
        xs: [{ required: true, message: '请输入学时', trigger: 'blur' }],
        kcnr: [{ required: true, message: '请输入课程内容', trigger: 'blur' }],
        syxm: [{ required: true, message: '请输入实验项目' }],
      },
      numberDialogVisible1: false,
      action: '',
      downloadUrl: 'template/实训导入模版.xlsx',
      downloadName: '实训导入模版.xlsx',
      btnTitle: '导入实训数据',
      exportUrl: '',
      wdsxsqs: [],
    };
  },
  created() {
    // this.action = `${this.baseUrlt}api/danger_goods/import`;
    // this.exportUrl = `${this.baseUrlt}api/consume/queryExport`;
    // this.$store.dispatch('getTarinMent');
    // this.$store.dispatch('getParams');
    this.getWdsxsq();
  },
  watch: {
    plist: {
      handler: function (val) {
        this.ruleForm.sxjhnr = JSON.stringify(val);
      },
      deep: true,
    },
  },
  computed: {
    total_price() {
      // this.total_price = this.quantity*this.price
      return (this.ruleForm.quantity * this.ruleForm.price * 1000) / 1000;
    },
  },
  mounted() { },
  methods: {
    handleDelet(id) {
      this.confirmBox('warning', `此操作将删除该大纲，是否继续`, { id }, this.deleteMethod);
    },
    isJsonString(str) {
      try {
        JSON.parse(str);
        return true;
      } catch {
        return false;
      }
    },
    handleItemDelete(item, index) {
      this.plist.splice(index, 1);
    },
    handleItemAdd() {
      this.plist.push({ sxnr: '', xs: 0, bz: '' });
    },
    handleQuery() {
      // this.beforeQuery();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    getOrganList() {
      this.beforeGetOrgan();
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.class_plan = this.$until.getLabelName(this.wdsxsqs, 'id', 'course_name', e);
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    async getWdsxsq() {
      let params = {
        page: 1,
        size: 9999,
        status: 'pass',
      };
      let res = await this.$api.instance.interfaceServer('api/xmhy/class/plan/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.wdsxsqs = res.data.data;
      }
    },
    async deleteMethod(params) {
      // let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/class_plan/outline/delete/${params.id}`, 'post');
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/class_plan/outline/add', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.instance.interfaceServer(`api/class_plan/outline/edit/${this.ruleForm.id}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/class_plan/outline/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleEdit(row, filterArr = ['updated_at', 'deleted_at', 'created_at', 'login_time']) {
      if (row.structure_1 && row.major) {
        this.selectName = `${row.structure_1}-${row.major}`;
      }
      this.type = 'edit';
      this.title = '编辑';
      this.ruleForm = this.$until.delProp(row, filterArr);
      console.log(this.ruleForm);
      this.centerDialogVisible = true;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}

/deep/.el-form-item .el-form-item {
  margin-bottom: 22px;
}
</style>
